import React, { Component } from 'react';
import { ModelsContext } from "./contexts/ModelsContext";

function modelsConsWrapper(WhatComponentNeedsWrapper) {
  const wrapper = class extends Component {

    render() {
      return (
        <ModelsContext.Consumer>
          {value =>
            <WhatComponentNeedsWrapper
              models={value.models}
              refreshModels={value.refreshModels}
              {...this.props}/>
          }
        </ModelsContext.Consumer>
      );
    }
  };

  wrapper.displayName = ((WhatComponentNeedsWrapper.displayName || WhatComponentNeedsWrapper.name) + " < modelsConsWrapper");
  return wrapper;
}

export { modelsConsWrapper };
